import { CommonModule } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    computed,
    inject,
    signal,
} from '@angular/core';
import { DxFileUploaderModule } from 'devextreme-angular/ui/file-uploader';

@Component({
    selector: 'app-form-photo',
    templateUrl: './form-photo.component.html',
    styleUrls: ['./form-photo.component.scss'],
    standalone: true,
    imports: [DxFileUploaderModule, CommonModule],
    changeDetection: ChangeDetectionStrategy.Default,
})
export class FormPhotoComponent implements OnInit, OnChanges {
    protected elRef = inject(ElementRef);
    @Input() link!: string;

    @Input() editable = false;

    @Input() size = 124;

    @Input() placeholder = '';

    @Output() fileSelected = new EventEmitter<File>();

    // Convert input to signal for reactivity
    linkSignal = signal<string | null>(null);

    // Computed signal that updates when linkSignal changes
    imageUrl = computed(() => {
        const raw = this.linkSignal();
        if (!raw) return '';

        // Support SafeResourceUrl and other non-string inputs
        const link: string = typeof raw === 'string' ? raw : (raw as any)?.changingThisBreaksApplicationSecurity || '';
        if (!link) return '';

        // Check if link is already a complete URL (http/https) or data URL
        if (link.startsWith('http://') || link.startsWith('https://') || link.startsWith('data:') || link.startsWith('blob:')) {
            return `url('${link}')`;
        }

        // Assume it's base64 data
        return `url('data:image/png;base64,${link}')`;
    });

    hostRef = this.elRef.nativeElement;

    ngOnInit(): void {
        // Initialize the signal with the input value
        this.linkSignal.set(this.link);
    }

    ngOnChanges(): void {
        // Update signal when input changes
        this.linkSignal.set(this.link);
    }

    onUploaderValueChanged(e: any): void {
        const files: File[] = e?.value || e?.component?._files || [];
        const file = Array.isArray(files) ? files[0] : undefined;
        if (file) {
            this.fileSelected.emit(file);
        }
    }
}
